/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axios from "axios";

import { toast } from "react-toastify";
import api from "../services/apiLogin";
import { UsuarioLogin } from "../interface/user";

interface Props {
  children?: React.ReactNode;
}

interface SignCredentials {
  USUARIO: string;
  SENHA: string;
  BASE: string;
  SISTEMA?: string;
  OTP?: string;
}

interface LoginResponse {
  success: boolean;
  requireOTP?: boolean;
  setupOTP?: boolean;
  qrCode?: string;
  tempSecret?: string;
  tempSecretBase64?: string; // ADICIONE ESTA LINHA
  message?: string;
  token?: string;
  refreshToken?: string;
}

interface AuthContextData {
  login({
    USUARIO,
    SENHA,
    BASE,
    SISTEMA,
    OTP,
  }: SignCredentials): Promise<LoginResponse>;
  confirmOTP({
    USUARIO,
    SENHA,
    BASE,
    OTP,
    tempSecret,
  }: SignCredentials & { tempSecret: string }): Promise<LoginResponse>;
  user: UsuarioLogin | null;
  logout(): void;
  loading: boolean;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

function AuthProvider({ children }: Props) {
  const [data, setData] = useState<UsuarioLogin | null>(null);
  const [loading, setLoading] = useState(false);
  const [ip, setIP] = useState("");

  useEffect(() => {
    const getIPData = async () => {
      const res = await axios.get("https://geolocation-db.com/json/");
      setIP(res.data.IPv4);
    };
    getIPData();
  }, []);

  useEffect(() => {
    const storedToken = sessionStorage.getItem("@webSDS:token");
    const storedUser = sessionStorage.getItem("@webSDS:usuario");

    if (storedToken && storedUser) {
      setData(JSON.parse(storedUser));
      // setSigned(true)
      api.defaults.headers.authorization = `Bearer ${storedToken}`;
    }

    // setLoading(false)
  }, []);

  const login = useCallback(
    async ({ USUARIO, SENHA, BASE, OTP }: SignCredentials) => {
      try {
        setLoading(true);
        console.log("api.base: ", api.defaults.baseURL);
        const response = await api.post("/login", {
          USUARIO,
          SENHA,
          BASE,
          SISTEMA: "policiaagil-web",
          IP: ip,
          OTP,
        });

        // 🔍 DEBUG: Logs detalhados da resposta
        console.log("========== RESPOSTA DO LOGIN ==========");
        console.log("Status:", response.status);
        console.log("Data (JSON):", JSON.stringify(response.data, null, 2));
        console.log("========================================");

        // Salvar no localStorage para análise posterior
        localStorage.setItem(
          "DEBUG_LAST_LOGIN_RESPONSE",
          JSON.stringify(response.data, null, 2)
        );

        // Mostrar dados específicos se existirem
        if (response.data) {
          console.log("📋 Dados do usuário:");
          console.log(
            "- Token:",
            response.data.token ? "✅ presente" : "❌ ausente"
          );
          console.log("- CPF:", response.data.cpf || "não informado");
          console.log("- Nome:", response.data.nome || "não informado");
          console.log(
            "- Sistemas:",
            response.data.sistemas
              ? `${response.data.sistemas.length} sistema(s)`
              : "não informado"
          );

          if (response.data.sistemas && response.data.sistemas.length > 0) {
            console.table(response.data.sistemas);
          }
        }

        // Backend retorna informações sobre OTP
        if (response.status === 200 && response.data.requireOTP) {
          setLoading(false);
          return {
            success: false,
            requireOTP: true,
            setupOTP: response.data.setupOTP || false,
            qrCode: response.data.qrCode,
            tempSecret: response.data.tempSecret,
            tempSecretBase64: response.data.tempSecretBase64, // ADICIONE ESTA LINHA
            message: response.data.message,
          };
        }

        // Login bem-sucedido
        if (
          response.status === 200 &&
          (response.data.token || response.data.success)
        ) {
          setData(response.data);
          const apiToken = response.data.token;

          api.defaults.headers.authorization = `Bearer ${apiToken}`;

          sessionStorage.setItem("@webSDS:token", apiToken);
          sessionStorage.setItem(
            "@webSDS:usuario",
            JSON.stringify(response.data)
          );
          setLoading(false);
          return {
            success: true,
            token: response.data.token,
            refreshToken: response.data.refreshToken,
          };
        }

        // Outros status codes de erro
        if (response.status === 400) {
          toast.error(`${response.data}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }

        if (response.status === 401) {
          const errorMessage = response.data?.message || response.data;
          toast.error(`${errorMessage}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }

        if (response.status === 404) {
          toast.error(`${response.data}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }

        if (response.status === 500 || response.status === 503) {
          toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }

        if (response.status === 504) {
          toast.error(
            "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
        }

        setLoading(false);
        return { success: false };
      } catch (err: any) {
        setLoading(false);

        toast.error(`ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
        return { success: false };
      }
    },
    [ip]
  );

  const confirmOTP = useCallback(
    async ({ USUARIO, SENHA, BASE, OTP, tempSecret, tempSecretBase64 }) => {
      console.log("Iniciando chamada para confirmOTP:", {
        USUARIO,
        OTP: OTP?.length ? "*".repeat(OTP.length) : "vazio",
        tempSecret: tempSecret ? `${tempSecret.substring(0, 5)}...` : "vazio",
        temTempSecretBase64: !!tempSecretBase64,
      });

      if (
        !USUARIO ||
        !SENHA ||
        !BASE ||
        !OTP ||
        (!tempSecret && !tempSecretBase64)
      ) {
        console.error("Dados incompletos para confirmOTP");
        return {
          success: false,
          message: "Dados incompletos para validação",
        };
      }

      // Se temos tempSecretBase64, decodificar para tempSecret
      let secretToUse = tempSecret;
      if (!secretToUse && tempSecretBase64) {
        try {
          secretToUse = atob(tempSecretBase64);
          console.log("Decodificado tempSecretBase64 com sucesso");
        } catch (e) {
          console.error("Erro ao decodificar tempSecretBase64:", e);
        }
      }

      try {
        const response = await api.post("/confirmOTP", {
          USUARIO,
          SENHA,
          BASE,
          OTP,
          tempSecret: secretToUse,
          SISTEMA: "policiaagil-web",
          IP: ip,
        });

        console.log("Resposta de confirmOTP:", response.data);

        if (
          response.status === 200 &&
          (response.data.token || response.data.success)
        ) {
          setData(response.data);
          const apiToken = response.data.token;

          api.defaults.headers.authorization = `Bearer ${apiToken}`;

          sessionStorage.setItem("@webSDS:token", apiToken);
          sessionStorage.setItem(
            "@webSDS:usuario",
            JSON.stringify(response.data)
          );

          setLoading(false);
          return {
            success: true,
            token: response.data.token,
            refreshToken: response.data.refreshToken,
          };
        }

        setLoading(false);
        return {
          success: false,
          message: response.data.message || "Erro na validação do código OTP",
        };
      } catch (err) {
        console.error("Erro em confirmOTP:", err);

        // Verifique se err é um objeto antes de acessar propriedades
        if (err && typeof err === "object" && "response" in err) {
          // Agora TypeScript sabe que err tem uma propriedade 'response'
          const errorObj = err as {
            response?: {
              status?: number;
              data?: { message?: string };
            };
          };

          console.error("Detalhes do erro:", {
            status: errorObj.response?.status,
            data: errorObj.response?.data,
          });

          setLoading(false);
          return {
            success: false,
            message:
              errorObj.response?.data?.message ||
              "Erro na validação do código OTP",
          };
        }

        setLoading(false);
        return {
          success: false,
          message: "Erro na validação do código OTP",
        };
      }
    },
    [ip]
  );

  const logout = useCallback(() => {
    sessionStorage.removeItem("@webSDS:token");
    sessionStorage.removeItem("@webSDS:usuario");

    setData(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        login,
        confirmOTP, // Adicione a nova função ao contexto
        user: data,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth deve ser usado em um AuthProvider");
  }

  return context;
}

export { useAuth, AuthProvider };
